import { jsx as r, jsxs as p, Fragment as x } from "react/jsx-runtime";
import { useState as C, useRef as w } from "react";
import { LinkAnchor as U } from "../../elements/link/link.js";
import { PlayButtonIndicator as B } from "../../elements/play-button/play-button-indicator.js";
import { VideoModal as E } from "../../elements/video-modal/video-modal.js";
import e from "./teaser-block.module.less.js";
import { isMobileDevice as L } from "../../../helpers/device-helper.js";
import { isOrHandleAsExternalUrl as _ } from "../../../helpers/link-helper.js";
import { getImageLoading as F } from "../../../helpers/image-helper.js";
import "dayjs";
import { Heading as H } from "../../elements/heading/heading.js";
import { m } from "motion/react";
import { useAnimateFadeIn as g, useAnimateFadeInToTop as Y } from "../../../animation/animation.js";
import { useTranslation as M } from "react-i18next";
const b = ({
  videoUrl: s,
  posterUrl: d,
  desktopMediaPosition: u,
  mediaShape: h,
  innerVideoWrapperAnimation: v,
  playButtonWrapperAnimation: i
}) => {
  const n = w(null), { t: a } = M(), t = () => {
    n.current && n?.current?.play();
  };
  return /* @__PURE__ */ r("div", { className: [e.videoWrapper, e[u]].join(" "), children: /* @__PURE__ */ p(
    m.button,
    {
      ...v,
      className: [e.innerVideoWrapper, e[h]].join(" "),
      onClick: t,
      "aria-label": a("PLAY_VIDEO"),
      children: [
        /* @__PURE__ */ r("video", { className: e.video, ref: n, src: s, preload: "auto", poster: d }),
        /* @__PURE__ */ r(m.div, { ...i, className: e.playButtonWrapper, children: /* @__PURE__ */ r(B, {}) })
      ]
    }
  ) });
}, V = ({
  posterUrl: s,
  videoUrl: d,
  youtubeVideoId: u,
  isVideoModalOpen: h,
  desktopMediaPosition: v,
  mediaShape: i,
  innerVideoWrapperAnimation: n,
  playButtonAnimation: a,
  onClickPlayButton: t,
  onCloseModalButton: o
}) => {
  const l = w(null), { t: c } = M();
  return /* @__PURE__ */ p("div", { className: [e.videoWrapper, e[v]].join(" "), children: [
    /* @__PURE__ */ p(
      m.button,
      {
        ...n,
        onClick: t,
        className: [e.innerVideoWrapper, e[i]].join(" "),
        "aria-label": c("PLAY_VIDEO"),
        children: [
          /* @__PURE__ */ r("div", { className: e.playButtonWrapper, children: /* @__PURE__ */ r(B, { animation: a }) }),
          /* @__PURE__ */ r("div", { className: e.videoPosterWrapper, children: /* @__PURE__ */ r("img", { className: e.videoPoster, src: s, alt: "" }) })
        ]
      }
    ),
    /* @__PURE__ */ r(
      E,
      {
        portalContainer: l.current ?? void 0,
        close: { function: o },
        onEscapeKeyDown: o,
        isOpen: h,
        videoUrl: d,
        youtubeVideoId: u
      }
    ),
    /* @__PURE__ */ r("div", { ref: l })
  ] });
}, re = ({
  date: s,
  eyebrow: d,
  heading: u,
  content: h,
  text: v,
  link: i,
  image: n,
  videoObject: a,
  youtubeVideoObject: t,
  backgroundVideoUrl: o,
  mediaShape: l = "standard",
  desktopMediaPosition: c = "right",
  index: y
}) => {
  const [A, f] = C(!1), I = { blockIndex: y }, N = g({ whileInView: !0, easing: "easeInOut" }, I), W = g({ whileInView: !0, delay: 0.3, duration: 0.3 }, I), T = Y({ whileInView: !0, delay: 0.3, easing: "easeOut" }, I), P = () => !!((a || t) && !n?.url && !o), D = a && !n?.url && !o, j = t && !a && !n?.url && !o;
  return /* @__PURE__ */ r("section", { className: e.wrapper, children: /* @__PURE__ */ p(
    "div",
    {
      className: [e.contentWrapper, P() ? e.videoMode : "", "max-width padded-sides"].join(" "),
      children: [
        /* @__PURE__ */ p("div", { className: e.textWrapper, children: [
          /* @__PURE__ */ p(m.div, { ...N, children: [
            (s || d) && /* @__PURE__ */ p("div", { className: e.tagDateWrapper, children: [
              s && /* @__PURE__ */ r("p", { className: [e.date, "eyebrow"].join(" "), children: s }),
              d && /* @__PURE__ */ r("p", { className: [e.eyebrow, "eyebrow"].join(" "), children: d })
            ] }),
            u && /* @__PURE__ */ r(
              H,
              {
                index: y,
                semanticType: "h2",
                visualType: "h3",
                className: [e.heading, "heading-max-width"].join(" "),
                children: u
              }
            ),
            h && /* @__PURE__ */ r(
              "div",
              {
                className: [e.content, "html-content"].join(" "),
                dangerouslySetInnerHTML: { __html: h }
              }
            ),
            v && /* @__PURE__ */ r("p", { className: ["body-base", e.text].join(" "), children: v })
          ] }),
          i && /* @__PURE__ */ r(m.div, { ...T, className: e.buttonWrapper, children: /* @__PURE__ */ r(
            U.Primary,
            {
              url: i?.url,
              label: i?.title,
              iconRight: "ui-icon-arrow-right",
              openInNewTab: _(i.url, i.target),
              onPreNavigate: i.onPreNavigate
            }
          ) })
        ] }),
        o && /* @__PURE__ */ r(
          m.div,
          {
            ...N,
            className: [e.backgroundMediaWrapper, e[c]].join(" "),
            children: /* @__PURE__ */ r("div", { className: [e.innerBackgroundMediaWrapper, e[l]].join(" "), children: /* @__PURE__ */ r("video", { className: e.backgroundVideo, src: o, playsInline: !0, autoPlay: !0, muted: !0, loop: !0 }) })
          }
        ),
        !o && n?.url && /* @__PURE__ */ r(
          m.div,
          {
            ...N,
            className: [e.backgroundMediaWrapper, e[c]].join(" "),
            children: /* @__PURE__ */ r("div", { className: [e.innerBackgroundMediaWrapper, e[l]].join(" "), children: /* @__PURE__ */ r("img", { className: e.image, src: n.url, alt: n.alt, loading: F(y) }) })
          }
        ),
        D && /* @__PURE__ */ r(x, { children: L() ? /* @__PURE__ */ r(
          b,
          {
            desktopMediaPosition: c,
            mediaShape: l,
            posterUrl: a.posterUrl,
            videoUrl: a.videoUrl,
            innerVideoWrapperAnimation: N,
            playButtonWrapperAnimation: W
          }
        ) : /* @__PURE__ */ r(
          V,
          {
            desktopMediaPosition: c,
            mediaShape: l,
            posterUrl: a.posterUrl,
            videoUrl: a.videoUrl,
            isVideoModalOpen: A,
            innerVideoWrapperAnimation: N,
            playButtonAnimation: W,
            onCloseModalButton: () => f(!1),
            onClickPlayButton: () => f(!0)
          }
        ) }),
        j && /* @__PURE__ */ r(
          V,
          {
            desktopMediaPosition: c,
            mediaShape: l,
            posterUrl: t?.posterUrl,
            youtubeVideoId: t?.youtubeVideoId,
            isVideoModalOpen: A,
            innerVideoWrapperAnimation: N,
            playButtonAnimation: W,
            onCloseModalButton: () => f(!1),
            onClickPlayButton: () => f(!0)
          }
        )
      ]
    }
  ) });
};
export {
  re as TeaserBlock,
  re as default
};
